module.exports = __webpack_public_path__ + "static/media/logo.c34dce33.jpg";